import { styled } from '@mui/material/styles'
import Box, {BoxProps} from '@mui/material/Box'


export const StatsBox = styled(Box)<BoxProps>(() => ({
    padding: '1rem',
    backgroundColor: '#f8fafa'
}))